export enum UserRoleEnum {
    superAdmin = "ROLE_SUPER_ADMIN",
    admin = "ROLE_ADMIN_SEGMENT",
    agent = "ROLE_AGENT",
    subAgent = "ROLE_SUBAGENT",
    curator = "ROLE_CURATOR",
    subCurator = "ROLE_SUBCURATOR",
    mentor = "ROLE_MENTOR",
    techSupport = "ROLE_TECH_SUPPORT",
    parentChanger = "ROLE_CHANGE_PARENT",

    allowSegmentationRead = "ROLE_SEGMENTATION_READ",
    allowSegmentationEdit = "ROLE_SEGMENTATION_EDIT",
    allowOtherSegmentationRead = "ROLE_SEGMENTATION_READ_OTHER_TREE",
    allowOtherSegmentationEdit = "ROLE_SEGMENTATION_EDIT_OTHER_TREE",
    allowBlockAgent = "ROLE_BLOCK_AGENT",
    allowBlockOtherAgent = "ROLE_BLOCK_OTHER_AGENT",
    allowCuratorEmailEdit = "ROLE_EDIT_CURATOR",
    allowOtherCuratorEmailEdit = "ROLE_EDIT_OTHER_CURATOR",
}
